export default "__VITE_ASSET__BSh8gx$4__"